import React, { memo } from "react";

import AppButton from "components/app-button";
import emptyBox from "assets/images/components/app-empty-state/empty-box.png";

const AppEmptyData = (props) => {

	return (
		<div className="app-empty-data">
			<div className="empty-data">
				{!props.disabledImage && <img className="empty-data__image" src={emptyBox} alt="is empty" />}	
				<p className="empty-data__title">{props.title}</p>
				<p className={props.disabledImage? "empty-data__card-description" : "empty-data__description" }>{props.description}</p>

				{props.buttons?.length > 0 && !props.hideButton && (
					<div className="app-search-input__button-container">
						{props.buttons.map((btn, i) => (
							<AppButton
								key={i}
								type="button"
								label={btn.label || "Add New"}
								icon={<img src={btn.icon} alt="" className="page-appointment__add-icon" style={{ marginRight: 5 }} />}
								onClick={btn.onClick}
								outline={btn.outline}
								disabled={btn.disabled}
							/>
						))}
					</div>
				)}
			</div>
		</div>
	);
};


export default memo(AppEmptyData);
